import { gql } from '@apollo/client';

/**
 * This query handles pagination in an unusual way:
 * If you provide for example ['ca', 'cauc'] as 'market'
 * and 12 as the limit, then you'll get back 24 results;
 * 12 from 'ca', and 12 from the 'cauc' market.
 *
 * If we later want to implement fetching data for multiple
 * markets, we'll have to investigate further as this can
 * potentially cause severe problems in the pagination logic
 */

// eslint-disable-next-line import/prefer-default-export
export const GET_AVAILABLE_FILTERS = gql`
  query getFilteredVehiclesForWormwood(
    $version: String
    $market: [MarketType]!
    $lang: String!
    $filters: String
    $ranges: String
    $preset: String
  ) {
    getFilteredVehiclesForWormwood(
      version: $version
      market: $market
      lang: $lang
      filters: $filters
      ranges: $ranges
      preset: $preset
    ) {
      filterResults {
        totalCount
        totalNewCarCount
        totalUsedCarCount
        available_from_soon
        available_from_immediately
        foreign_brand_yes
        foreign_brand_no
        nonAudiManufactures {
          active
          code
          count
        }
        nonAudiModels {
          active
          code
          count
        }
        nonAudiFilterResultCounts {
          bodyTypes {
            active
            code
            count
          }
          fuelTypes {
            active
            code
            count
          }
          exteriorColors {
            active
            code
            count
          }
          manufactures {
            active
            code
            count
          }
          models {
            active
            code
            count
          }
        }
        available_in_months {
          selected
          minValue
        }
        has_warranties {
          all {
            active
            count
          }
          yes {
            active
            count
          }
          no {
            active
            count
          }
        }
        body_type {
          allroad_quattro {
            active
            count
          }
          avant {
            active
            count
          }
          cabriolet {
            active
            count
          }
          coupe {
            active
            count
          }
          limousine {
            active
            count
          }
          roadster {
            active
            count
          }
          sedan {
            active
            count
          }
          sportback {
            active
            count
          }
          spyder {
            active
            count
          }
          suv {
            active
            count
          }
        }
        model_range {
          a3 {
            active
            count
          }
          a4 {
            active
            count
          }
          a5 {
            active
            count
          }
          a6 {
            active
            count
          }
          a6etron {
            active
            count
          }
          a7 {
            active
            count
          }
          a8 {
            active
            count
          }
          etron {
            active
            count
          }
          etrongt {
            active
            count
          }
          etrons {
            active
            count
          }
          q3 {
            active
            count
          }
          q4 {
            active
            count
          }
          q5 {
            active
            count
          }
          q5tfsie {
            active
            count
          }
          q6etron {
            active
            count
          }
          sq6etron {
            active
            count
          }
          q7 {
            active
            count
          }
          q8 {
            active
            count
          }
          r8 {
            active
            count
          }
          rs3 {
            active
            count
          }
          rs4 {
            active
            count
          }
          rs5 {
            active
            count
          }
          rs6 {
            active
            count
          }
          rs7 {
            active
            count
          }
          rsetrongt {
            active
            count
          }
          rsq8 {
            active
            count
          }
          s3 {
            active
            count
          }
          s4 {
            active
            count
          }
          s5 {
            active
            count
          }
          s6 {
            active
            count
          }
          s6etron {
            active
            count
          }
          s7 {
            active
            count
          }
          s8 {
            active
            count
          }
          q8etron {
            active
            count
          }
          sq8etron {
            active
            count
          }
          sq5 {
            active
            count
          }
          sq7 {
            active
            count
          }
          sq8 {
            active
            count
          }
          tt {
            active
            count
          }
          ttrs {
            active
            count
          }
          tts {
            active
            count
          }
        }
        trimline {
          comfort {
            active
            count
          }
          progressive {
            active
            count
          }
          technik {
            active
            count
          }
          premium {
            active
            count
          }
          premium_plus {
            active
            count
          }
          prestige {
            active
            count
          }
          other {
            active
            count
          }
        }
        wheel {
          size_15 {
            active
            count
          }
          size_16 {
            active
            count
          }
          size_17 {
            active
            count
          }
          size_18 {
            active
            count
          }
          size_19 {
            active
            count
          }
          size_20 {
            active
            count
          }
          size_21 {
            active
            count
          }
          size_22 {
            active
            count
          }
          size_23 {
            active
            count
          }
        }
        drive {
          fwd {
            active
            count
          }
          quattro {
            active
            count
          }
          rwd {
            active
            count
          }
        }
        gear_type {
          automatic {
            active
            count
          }
          manual {
            active
            count
          }
        }
        vtp_drivetrain {
          gasoline {
            active
            count
          }
          diesel {
            active
            count
          }
          electrical {
            active
            count
          }
          gasoline_hybrid {
            active
            count
          }
        }
        interior_color_seats {
          black {
            active
            count
          }
          white {
            active
            count
          }
          gray {
            active
            count
          }
          red {
            active
            count
          }
          brown {
            active
            count
          }
          beige {
            active
            count
          }
          default {
            active
            count
          }
        }
        exterior_color {
          black {
            active
            count
          }
          white {
            active
            count
          }
          gray {
            active
            count
          }
          silver {
            active
            count
          }
          blue {
            active
            count
          }
          red {
            active
            count
          }
          green {
            active
            count
          }
          brown {
            active
            count
          }
          yellow {
            active
            count
          }
          beige {
            active
            count
          }
          orange {
            active
            count
          }
          default {
            active
            count
          }
        }
      }
      rangeResults {
        priceRetail {
          max {
            maxValue
            selected
          }
          min {
            minValue
            selected
          }
          count
        }
        modelYear {
          max {
            maxValue
            selected
          }
          min {
            minValue
            selected
          }
          count
        }
        powerHP {
          max {
            maxValue
            selected
          }
          min {
            minValue
            selected
          }
          count
        }
        usedCarMileage {
          max {
            maxValue
            selected
          }
          min {
            minValue
            selected
          }
          count
        }
      }
    }
  }
`;
